import { CodeItemStatusCode } from "web/hooks/useCodeItemStatus/useCodeItemStatus";

const labels = {
  showCodeLabel: "Zobacz kod",
  codeWaitingLabel: "Oczekuje na kod",
  codeCanceledLabel: "Kod anulowany",
  codeWaitingForPaymentLabel: "Oczekuje na płatność",
  codeToWithdrawLabel: "Zgłoszono odstąpienie",
  codeWithdrawingLabel: "W trakcie zwrotu",
  codeWithdrawnLabel: "Odstąpiono od zakupu",
  codeWithdrawnErrorLabel: "Błąd zwrotu",
};

const codeLabelMap: Record<
  CodeItemStatusCode,
  (typeof labels)[keyof typeof labels]
> = {
  [CodeItemStatusCode.AVAILABLE]: labels.showCodeLabel,
  [CodeItemStatusCode.CANCELED]: labels.codeCanceledLabel,
  [CodeItemStatusCode.EXPIRED]: labels.showCodeLabel,
  [CodeItemStatusCode.USED]: labels.showCodeLabel,
  [CodeItemStatusCode.WAITING]: labels.codeWaitingLabel,
  [CodeItemStatusCode.WAITING_FOR_PAYMENT]: labels.codeWaitingForPaymentLabel,
  [CodeItemStatusCode.TO_WITHDRAW]: labels.codeToWithdrawLabel,
  [CodeItemStatusCode.WITHDRAWING]: labels.codeWithdrawingLabel,
  [CodeItemStatusCode.WITHDRAWN]: labels.codeWithdrawnLabel,
  [CodeItemStatusCode.WITHDRAWN_ERROR]: labels.codeWithdrawnErrorLabel,
};

export default codeLabelMap;
